<template>
    <div class="content-wrapper">
        <div class="general-setting col-md-10 mx-auto">
            <app-overlay-loader v-if="preloader"/>
            <form v-else ref="form" data-url="payroll-settings/1" enctype="multipart/form-data"
                  class="mb-0"
                  :class="{'loading-opacity': preloader}">
                <!-- Payroll Settings -->
                <fieldset class="form-group mb-5">
                    <div class="row">
                        <h5 class="col-12 pt-0 mb-3">
                            {{ $t('payroll_settings') }}
                        </h5>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsCompanyName" class="col-form-label">
                                            {{ $t('company_name') }}
                                        </label>
                                        <app-input id="payrollSettingsCompanyName"
                                                   type="text"
                                                   v-model="payrollSettings.company_name"
                                                   :placeholder="$t('type_your_company_name')"
                                                   :required="true"/>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsCompanyType" class="col-form-label">
                                            {{ $t('company_type') }}
                                        </label>
                                        <app-input id="payrollSettingsCompanyType"
                                                   type="select"
                                                   v-model="payrollSettings.company_type"
                                                   :list="typeList"
                                                   :required="true"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsActivityBranch" class="col-form-label">
                                            {{ $t('activity_branch') }}
                                        </label>
                                        <app-input id="payrollSettingsActivityBranch"
                                                   type="text"
                                                   v-model="payrollSettings.activity_branch"
                                                   :placeholder="$t('type_activity_branch')"/>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsFiscalNumber" class="col-form-label">
                                            {{ $t('fiscal_number') }}
                                        </label>
                                        <app-input id="payrollSettingsFiscalNumber"
                                                   type="text"
                                                   v-model="payrollSettings.fiscal_number"
                                                   :placeholder="$t('type_fiscal_number')"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsCnssNumber" class="col-form-label">
                                            {{ $t('cnss_number') }}
                                        </label>
                                        <app-input id="payrollSettingsCnssNumber"
                                                   type="text"
                                                   v-model="payrollSettings.cnss_number"
                                                   :placeholder="$t('type_your_cnss_number')"/>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsInppNumber" class="col-form-label">
                                            {{ $t('inpp_number') }}
                                        </label>
                                        <app-input id="payrollSettingsInppNumber"
                                                   type="text"
                                                   v-model="payrollSettings.inpp_number"
                                                   :placeholder="$t('type_inpp_number')"/>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsInppNumber" class="col-form-label">
                                            {{ $t('onem_number') }}
                                        </label>
                                        <app-input id="payrollSettingsInppNumber"
                                                   type="text"
                                                   v-model="payrollSettings.onem_number"
                                                   :placeholder="$t('type_onem_number')"/>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsInppNumber" class="col-form-label">
                                            {{ $t('id_nat') }}
                                        </label>
                                        <app-input id="payrollSettingsInppNumber"
                                                   type="text"
                                                   v-model="payrollSettings.id_nat"
                                                   :placeholder="$t('type_id_nat')"/>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsRccmNumber" class="col-form-label">
                                            {{ $t('rccm_number') }}
                                        </label>
                                        <app-input id="payrollSettingsRccmNumber"
                                                   type="text"
                                                   v-model="payrollSettings.rccm_number"
                                                   :placeholder="$t('type_rccm_number')"/>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsUsdExchangeRate" class="col-form-label">
                                            {{ $t('usd_exchange_rate') }}
                                        </label>
                                        <app-input id="payrollSettingsUsdExchangeRate"
                                                   type="number"
                                                   v-model="payrollSettings.usd_exchange_rate"
                                                   :placeholder="$t('type_usd_exchange_rate')"
                                                   :required="true"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsWorkingDaysPerMonth" class="col-form-label">
                                            {{ $t('working_days_per_month') }}
                                        </label>
                                        <app-input id="payrollSettingsWorkingDaysPerMonth"
                                                   type="number"
                                                   v-model="payrollSettings.working_days_per_month"
                                                   :placeholder="$t('type_working_days_per_month')"
                                                   :required="true"/>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsWorkingHoursPerDay" class="col-form-label">
                                            {{ $t('working_hours_per_day') }}
                                        </label>
                                        <app-input id="payrollSettingsWorkingHoursPerDay"
                                                   type="number"
                                                   v-model="payrollSettings.working_hours_per_day"
                                                   :placeholder="$t('type_working_hours_per_day')"
                                                   :required="true"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsCnssEmployerRate" class="col-form-label">
                                            {{ $t('cnss_employer_rate') }}
                                        </label>
                                        <app-input id="payrollSettingsCnssEmployerRate"
                                                   type="number"
                                                   v-model="payrollSettings.cnss_employer_rate"
                                                   :placeholder="$t('type_cnss_employer_rate')"
                                                   :required="true"/>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsInppRate" class="col-form-label">
                                            {{ $t('inpp_rate') }}
                                        </label>
                                        <app-input id="payrollSettingsInppRate"
                                                   type="number"
                                                   v-model="payrollSettings.inpp_rate"
                                                   :placeholder="$t('type_inpp_rate')"
                                                   :required="true"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsOnemRate" class="col-form-label">
                                            {{ $t('onem_rate') }}
                                        </label>
                                        <app-input id="payrollSettingsOnemRate"
                                                   type="number"
                                                   v-model="payrollSettings.onem_rate"
                                                   :placeholder="$t('type_onem_rate')"
                                                   :required="true"/>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsCnssEmployeeRate" class="col-form-label">
                                            {{ $t('cnss_employee_rate') }}
                                        </label>
                                        <app-input id="payrollSettingsCnssEmployeeRate"
                                                   type="number"
                                                   v-model="payrollSettings.cnss_employee_rate"
                                                   :placeholder="$t('type_cnss_employee_rate')"
                                                   :required="true"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsUnionContributionUsd" class="col-form-label">
                                            {{ $t('union_contribution_usd') }}
                                        </label>
                                        <app-input id="payrollSettingsUnionContributionUsd"
                                                   type="number"
                                                   v-model="payrollSettings.union_contribution_usd"
                                                   :placeholder="$t('type_union_contribution_usd')"
                                                   />
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsBankFeesUsd" class="col-form-label">
                                            {{ $t('bank_fees_usd') }}
                                        </label>
                                        <app-input id="payrollSettingsBankFeesUsd"
                                                   type="number"
                                                   v-model="payrollSettings.bank_fees_usd"
                                                   :placeholder="$t('type_bank_fees_usd')"
                                                   :required="true"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="payrollSettingsIprBrackets" class="col-form-label">
                                            {{ $t('ipr_brackets') }}
                                        </label>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>{{ $t('minimum') }}</th>
                                                        <th>{{ $t('maximum') }}</th>
                                                        <th>{{ $t('rate') }}</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(bracket, index) in iprBrackets" :key="index">
                                                        <td>
                                                            <app-input type="number" v-model="bracket.min" :placeholder="$t('min')" />
                                                        </td>
                                                        <td>
                                                            <app-input type="number" v-model="bracket.max" :placeholder="$t('max')" />
                                                        </td>
                                                        <td>
                                                            <app-input type="number" v-model="bracket.rate" :placeholder="$t('rate')" />
                                                        </td>
                                                        <td>
                                                            <button class="btn btn-danger" @click="removeBracket(index)">{{ $t('delete') }}</button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <button class="btn btn-primary" @click="addBracket">{{ $t('add_bracket') }}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsHousingAllowancePercent" class="col-form-label">
                                            {{ $t('housing_allowance_percent') }}
                                        </label>
                                        <app-input id="payrollSettingsHousingAllowancePercent"
                                                   type="number"
                                                   v-model="payrollSettings.housing_allowance_percent"
                                                   :placeholder="$t('type_housing_allowance_percent')"
                                                   :required="true"/>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsIprDependentMax" class="col-form-label">
                                            {{ $t('ipr_dependent_max') }}
                                        </label>
                                        <app-input id="payrollSettingsIprDependentMax"
                                                   type="number"
                                                   v-model="payrollSettings.ipr_dependent_max"
                                                   :placeholder="$t('type_ipr_dependent_max')"
                                                   :required="true"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsIprDeductionPerDependent" class="col-form-label">
                                            {{ $t('ipr_deduction_per_dependent') }}
                                        </label>
                                        <app-input id="payrollSettingsIprDeductionPerDependent"
                                                   type="number"
                                                   v-model="payrollSettings.ipr_deduction_per_dependent"
                                                   :placeholder="$t('type_ipr_deduction_per_dependent')"
                                                   :required="true"/>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="payrollSettingsIprCeilingPercent" class="col-form-label">
                                            {{ $t('ipr_ceiling_percent') }}
                                        </label>
                                        <app-input id="payrollSettingsIprCeilingPercent"
                                                   type="number"
                                                   v-model="payrollSettings.ipr_ceiling_percent"
                                                   :placeholder="$t('type_ipr_ceiling_percent')"
                                                   :required="true"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
    
                <div class="mt-2 action-buttons">
                    <button class="btn btn-primary mr-2" @click.prevent="submit">
                        {{ $t('save') }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import {FormMixin} from "../../../../core/mixins/form/FormMixin";
    import * as actions from "../../../Config/ApiUrl";
    import { SettingsStoreMixin } from "../Settings/Mixins/SettingsStoreMixin";

    export default {
        name: "GeneralSetting",
        mixins: [FormMixin, SettingsStoreMixin],
        data() {
            return {
                preloader: false,
                payrollSettings: {
                    company_name: '',
                    company_type: '',
                        activity_branch: '',
                        fiscal_number: '',
                    cnss_number: '',
                        inpp_number: '',
                        rccm_number: '',
                    usd_exchange_rate: '',
                    working_days_per_month: '',
                    working_hours_per_day: '',
                    cnss_employer_rate: '',
                    inpp_rate: '',
                    onem_rate: '',
                    cnss_employee_rate: '',
                    union_contribution_usd: '',
                    bank_fees_usd: '',
                    housing_allowance_percent: '',
                    ipr_brackets: '[]', // Valeur par défaut pour éviter l'erreur
                    ipr_dependent_max: '',
                    ipr_deduction_per_dependent: '',
                    ipr_ceiling_percent: ''
                },
                typeList: [
                    {
                        id: 'private',
                        value: this.$t('private')
                    },
                    {
                        id: 'public',
                        value: this.$t('public')
                    },
                ],
                iprBrackets: [] // Initialisation après payrollSettings
            };
        },
        created() {
            this.data();
            this.selectedUrl = `payroll-settings/1`;
        },
        computed: {
        },
        methods: {
            data() {
                this.preloader = true;
                this.axiosGet(`payroll-settings/1`).then(response => {
                    this.payrollSettings = response.data;
                    this.iprBrackets = JSON.parse(this.payrollSettings.ipr_brackets || '[]'); // Mise à jour après récupération des données
                }).catch(({ response }) => {
                    this.$toastr.e(response.data.message);
                }).finally(() => {
                    this.preloader = false;
                });
            },
            beforeSubmit(){
                this.preloader = true;
            },
            submit() {
                this.payrollSettings.ipr_brackets = JSON.stringify(this.iprBrackets);
                this.save(this.payrollSettings);
            },
            addBracket() {
                this.iprBrackets.push({ min: 0, max: null, rate: 0 });
            },
            removeBracket(index) {
                this.iprBrackets.splice(index, 1);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
                this.data();
            },
            afterFinalResponse() {
                this.preloader = false;
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
        }
    }
</script>
